import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-refresh\">\n<g id=\"icon-refresh_icon\">\n<rect id=\"icon-refresh_Rectangle 7741\" width=\"36\" height=\"36\" rx=\"4\" fill=\"#E7F0F4\" />\n<g id=\"icon-refresh_Group 177935\">\n<path id=\"icon-refresh_Vector\" d=\"M15.5 16V23.5H21.5V16H26L18.5 8.5L11 16H15.5ZM11 27H26V25.5H11V27Z\" fill=\"#789CB9\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/refresh.svg
// module id = SLu3
// module chunks = 102